import clientEnTranslation from './client/__i18n__/en';
import clientFrTranslation from './client/__i18n__/fr';
import commonEnTranslation from './common/__i18n__/en';
import commonFrTranslation from './common/__i18n__/fr';
import findingEnTranslation from './finding/__i18n__/en';
import findingFrTranslation from './finding/__i18n__/fr';
import errorEnTranslation from './error/__i18n__/en';
import errorFrTranslation from './error/__i18n__/fr';
import mapEnTranslation from './map/__i18n__/en';
import mapFrTranslation from './map/__i18n__/fr';
import missionEnTranslation from './mission/__i18n__/en';
import missionFrTranslation from './mission/__i18n__/fr';
import patrolEnTranslation from './patrol/__i18n__/en';
import patrolFrTranslation from './patrol/__i18n__/fr';

export default {
  fallbackLng: 'en',
  supportedLngs: ['en', 'fr'],
  detection: {
    order: ['localStorage'],
    lookupLocalStorage: 'i18nextLng',
  },
  resources: {
    en: {
      translation: {
        client: clientEnTranslation,
        common: commonEnTranslation,
        finding: findingEnTranslation,
        error: errorEnTranslation,
        map: mapEnTranslation,
        mission: missionEnTranslation,
        patrol: patrolEnTranslation,
      },
    },
    fr: {
      translation: {
        client: clientFrTranslation,
        common: commonFrTranslation,
        finding: findingFrTranslation,
        error: errorFrTranslation,
        map: mapFrTranslation,
        mission: missionFrTranslation,
        patrol: patrolFrTranslation,
      },
    },
  },
};
